import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./pricingModelsSection.scss";
import {
  FiRefreshCw,
  FiPieChart,
  FiTrendingUp,
  FiDollarSign,
  FiLayers,
} from "react-icons/fi";

const PricingModelsSection = () => {
  const models = [
    {
      icon: <FiRefreshCw />,
      title: "Subscription Build Model",
      description:
        "Predictable monthly costs with clear deliverables. Ideal for founders who want to retain full equity while building fast.",
      theme: "blue",
    },
    {
      icon: <FiPieChart />,
      title: "Equity-Swap Programs",
      description:
        "Exchange a portion of equity for development services. Perfect for high-potential startups conserving cash flow.",
      theme: "yellow",
    },
    {
      icon: <FiTrendingUp />,
      title: "Low Upfront, High Equity",
      description:
        "Designed for TRLvRs 1-2. Minimise initial cash outlay in exchange for a larger equity stake, aligning long-term incentives.",
      theme: "pink",
    },
    {
      icon: <FiDollarSign />,
      title: "Finance Partner Model",
      description:
        "Leverage our network of 3rd-party financing partners to fund your build without immediate dilution.",
      theme: "green",
    },
    {
      icon: <FiLayers />,
      title: "Custom Hybrid Models",
      description:
        "A tailored mix of cash and equity that suits your specific funding stage and runway requirements.",
      theme: "purple",
    },
  ];

  return (
    <section className="pricing-models-section" id="pricing-models">
      <div className="body-container">
        <RevealAnimation>
          <div className="section-header">
            <span className="section-badge">Investment Models</span>
            <h2>Founder-Friendly Pricing</h2>
            <p className="subtitle">
              Multiple models based on your ventureRyte TRL score
            </p>
          </div>
        </RevealAnimation>

        <div className="carousel-container">
          <div className="carousel-track">
            {/* First set of items */}
            {models.map((model, index) => (
              <div
                className={`model-card theme-${model.theme}`}
                key={`first-${index}`}
              >
                <div className="card-top">
                  <div className="icon-wrapper">{model.icon}</div>
                </div>
                <div className="card-bottom">
                  <h3>{model.title}</h3>
                  <p>{model.description}</p>
                </div>
              </div>
            ))}
            {/* Duplicate set for infinite scroll effect */}
            {models.map((model, index) => (
              <div
                className={`model-card theme-${model.theme} duplicate`}
                key={`second-${index}`}
              >
                <div className="card-top">
                  <div className="icon-wrapper">{model.icon}</div>
                </div>
                <div className="card-bottom">
                  <h3>{model.title}</h3>
                  <p>{model.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <RevealAnimation delay={0.5}>
          <div className="pricing-note">
            <p>
              Founders only pay baseline OPEX, never inflated agency retainers.
            </p>
          </div>
        </RevealAnimation>
      </div>
    </section>
  );
};

export default PricingModelsSection;
